exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".status-logs-popup-container {\n    background-color: #F0F0F0;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/common/status-logs-popup/status-logs-popup.component.css
// module id = ../../../../../src/app/shared/components/common/status-logs-popup/status-logs-popup.component.css
// module chunks = main